// Plausible analytics REMOVED (2026-10-14): HHG Plausible server has been
// decommissioned — plausible.hellohealthgroup.com serves an expired cert and
// 404s on every path. Keeping a no-op shim (instead of deleting 20+ call
// sites) so no component breaks; events are silently discarded.
// To fully remove later: drop this file + plausibleAPI imports + the
// plausible-tracker dependency + REACT_APP_PLAUSIBLE_* env vars.
/* eslint-disable @typescript-eslint/no-explicit-any */
const noop = () => undefined

export const plausibleAPI = {
  trackEvent: noop as (...args: any[]) => void,
  trackPageview: noop as (...args: any[]) => void
}

export default plausibleAPI
